// dummy wrappers to allow being parsed by
// i18next-parser in next-app for translations

/**
 * @deprecated Use common/internationalization/utils.t instead
 *
 * DUMMY TRANSLATION FUNCTION
 *
 * This is so that the i18next-parser can parse the t() calls in the next-app.
 * You would only use this if you are in an area of the codebase that does not support hooks, but would
 * still like the i18next-parser to parse the t() calls.
 *
 * At runtime, if this function is used directly it will NOT translate the input.
 * @param input
 * @returns input
 */
export const t = (input: string): string => input;

/**
 * @deprecated Use common/internationalization/utils.useTranslation instead
 *
 * DUMMY TRANSLATION FUNCTION
 *
 * This is so that the i18next-parser can parse the useTranslation() calls in the next-app and provide a
 * namespace for the subsequent t() calls it sees.
 * You would only use this if you are in an area of the codebase that does not support hooks, but would
 * still like the i18next-parser to parse the namespace for t() calls that follow.
 *
 * At runtime, if this function is used directly it will NOT translate the input.
 * @param input
 * @returns input
 */
export const useTranslation = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _: string
): {
  t: typeof t;
} => ({
  t,
});
